export default __webpack_public_path__ + "google_step.4aa2847.png";